import { useQuery } from '@tanstack/react-query'
import { getClassificationRowStatus } from '@global/api'

const KEY = 'classificationRowStatusQuery'

interface IArgs {
  datasetId: string
  refetchInterval?: number | null
  enabled: boolean
}

export const useClassificationRowStatusQuery = ({
  datasetId,
  refetchInterval = 3000,
  enabled,
}: IArgs) =>
  useQuery({
    queryKey: [KEY, datasetId],
    queryFn: ({ signal }) =>
      getClassificationRowStatus({
        datasetId,
        signal,
      }),
    enabled,
    ...(refetchInterval !== null ? { refetchInterval } : {}),
    cacheTime: 0,
    retry: false,
  })
